(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Campagna', Campagna);

    Campagna.$inject = ['$resource', 'DateUtils'];

    function Campagna ($resource, DateUtils) {
        var resourceUrl =  'api/campagnas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dtStart = DateUtils.convertDateTimeFromServer(data.dtStart);
                        data.dtEnd = DateUtils.convertDateTimeFromServer(data.dtEnd);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
